import React,{ useState, useEffect,useRef,useMemo,useContext } from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { editPortalSubmission, getSpecificPortalSubmissions } from '../../api/axiosPortalSubmissions';
import ProcessDiscard from '../../components/buttonActions/ProcessDiscard';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';  
import { Tag } from 'primereact/tag';     
import { useNavigate } from 'react-router-dom';
import useWindowSize from '../../hooks/useWindowSize';
import DataContext from '../../context/DataContext';
import { Skeleton } from 'primereact/skeleton';
import { Paginator } from 'primereact/paginator';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import { Dialog } from 'primereact/dialog';
import IncidentForm from '../../components/incident/IncidentForm';
import { createIncident } from '../../api/axiosIncidents';
import { getAllCountries } from '../../api/axiosCountries';
import { getCountryRegions} from '../../api/axiosRegions';
import { getRegionDistricts } from '../../api/axiosDistricts';
import { getDistrictWards } from '../../api/axiosWards';
import { getAllBroadCategories } from '../../api/axiosBroadCategories';
import { getBroadCategoryCategories } from '../../api/axiosCategories';
import { getCategorySubCategories } from '../../api/axiosSubCategories';
import { getBroadCategoryRights } from '../../api/axiosRights';
import { getAllEducationLevels } from '../../api/axiosEducationLevels';
import { getAllReligions } from '../../api/axiosReligions';
import { getAllVulnerabilities } from '../../api/axiosVulnerabilities';
import { getAllDisabilities } from '../../api/axiosDisabilities';
import { getAllMaritalStatuses } from '../../api/axiosMaritalStatuses';
import { getAllTribes } from '../../api/axiosTribes';
import { getAllEmploymentSectors } from '../../api/axiosEmploymentSectors';
import { getAllEmploymentStatuses } from '../../api/axiosEmploymentStatuses';
import { getAllMarriageTypes } from '../../api/axiosMarriageTypes';
import { getAllRoles } from '../../api/axiosRoles';
import { getAllZones } from '../../api/axiosZones';
import { getNotifications } from '../../api/axiosNotifications';
import { getAllRegions } from '../../api/axiosRegions';






const PortalSubmissions = ({maincardtitlex}) => {
 
  const {
    portalSubmissions, setPortalSubmissions,
    fetcherror, setFetcherror,
    countries, setCountries,
    regions, setRegions,
    districts, setDistricts,
    wards, setWards,
    broadCategories, setBroadCategories,
    categories, setCategories,
    subCategories, setSubCategories,
    rights, setRights,
    religions, setReligions,
    tribes, setTribes,
    educationLevels, setEducationLevels,
    employmentStatuses, setEmploymentStatuses,
    employmentSectors, setEmploymentSectors,
    maritalStatuses, setMaritalStatuses,
    marriageTypes, setMarriageTypes,
    vulnerabilities, setVulnerabilities,
    disabilities, setDisabilities,
    roles, setRoles, auntheticatedUser,
    notifications, setNotifications,
    isLoadingNotifications, setIsLoadingNotifications,
    fetcherrorNotifications, setFetcherrorNotifications
    

  
  } = useContext(DataContext);
 

  const toast = useRef(null);
  const fileUploadRef = useRef(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);



  // Incident Edit.
  const fileBrowseOption1 = <span><i className="pi pi-upload" style={{ fontSize: '1rem' }}></i> &nbsp; Choose the File to Upload</span>
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [fistNameReporter, setFistNameReporter] = useState("");
  const [lastNameReporter, setLastNameReporter] = useState("");
  const [selectedReporterRole,setSelectedReporterRole] = useState("");
  const [phoneReporter, setPhoneReporter] = useState("");
  const [emailReporter, setEmailReporter] = useState("");
  const [selectedSexReporter, setSelectedSexReporter] = useState("");

  const [incidentDescription, setIncidentDescription] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("TANZANIA");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedWard, setSelectedWard] = useState("");
  const [street, setStreet] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [selectedBroadCategory, setSelectedBroadCategory] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedRight, setSelectedRight] = useState("");
  const [stepsTaken, setStepsTaken] = useState(true);
  const [stepsDescription, setStepsDescription] = useState("");

  const [fistNameVictim, setFistNameVictim] = useState("");
  const [middleNameVictim, setMiddleNameVictim] = useState("");
  const [lastNameVictim, setLastNameVictim] = useState("");
  const [selectedSexVictim, setSelectSetSexVictim] = useState("");
  // const [emailVictim, setEmailVictim] = useState("");
  const [selectedBirthDayVictim, setSelectedBirthDayVictim] = useState("");
  const [selectedBirthMonthVictim, setSelectedBirthMonthVictim] = useState("");
  const [birthYearVictim, setBirthYearVictim] = useState("");
  const [phoneVictim, setPhoneVictim] = useState("");
  const [selectedEducationLevelVictim, setESelectedEducationLevelVictim] = useState("");
  const [selectedReligionVictim, setSelectedReligionVictim] = useState("");
  const [selectedTribeVictim, setSelectedTribeVictim] = useState("");
  const [childrenVictim, setChildrenVictim] = useState("");
  const [selectedMaritalStatusVictim, setSelectedMaritalStatusVictim] = useState("");
  const [selectedMarriageTypeVictim, setSelectedMarriageTypeVictim] = useState("");
  const [selectedEmploymentStatusVictim, setSelectedEmploymentStatusVictim] = useState("");
  const [selectedEmploymentSectorVictim, setSelectedEmploymentSectorVictim] = useState("");
  const [isVictimVulnerable, setIsVictimVulnerable] = useState(false);
  const [selectedVulnerabilityVictim, setSelectedVulnerabilityVictim] = useState("");
  const [isDisabled,setIsDisabled] = useState(false);
  const [selectedDisabilityVictim, setSelectedDisabilityVictim] = useState("");


  const [fullNamePerpetrator, setFullNamePerpetrator] = useState("");
  const [selectedSexPerpetrator, setSelectedSexPerpetrator] = useState("");
  const [phonePerpetrator, setPhonePerpetrator] = useState("");
  const [relationship, setRelationship] = useState("");
  const [assitanceNeeded, setAssitanceNeeded] = useState(false);
  const [assitanceDescription, setAssitanceDescription] = useState("");
  const [files, setFiles] = useState(null);
  const [zones, setZones] = useState([]);
  const [selectedZone, setSelectedZone] = useState("");
  
  const [allRegions, setAllRegions] = useState([]);
  const [portalSubmissionpkid, setPortalSubmissionpkid] = useState("");
 
  const [incidentstatus, setIncidentstatus] = useState("");
  const [incidentValidity, setIncidentValidity] = useState(false);
  const EditDialogHeader = (<div className='text-center mb-0'>Process Incident</div>);
  
  const createDaysArray =() => { 
    const daysArray = [];
      for (let i = 1; i <= 31; i++) {
        const dayValue = i < 10 ? "0" + i : "" + i;
        const dayObject = { day: dayValue, stringValue:dayValue };
        daysArray.push(dayObject);
    }
    return daysArray;
  }

  const daysArray = createDaysArray();


  const createMonthArray = () => {
    const monthsArray = [];
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    
    for (let i=0; i < 12; i++) { 
      let value;
      if (i < 9) { value = "0" + (i + 1); } else { value = (i+1).toString(); }
      let monthsObject = { month: months[i], stringValue: value }
      monthsArray.push(monthsObject);
    }
    return monthsArray;
  }

const monthsArray = createMonthArray();

  useEffect(() => {
    getAllCountries(setCountries, setFetcherror);
    getAllBroadCategories(setBroadCategories, setFetcherror);
    getAllEducationLevels(setEducationLevels, setFetcherror);
    getAllReligions(setReligions, setFetcherror);
    getAllTribes(setTribes, setFetcherror);
    getAllMaritalStatuses(setMaritalStatuses, setFetcherror);
    getAllVulnerabilities(setVulnerabilities, setFetcherror);
    getAllDisabilities(setDisabilities, setFetcherror)
    getAllMarriageTypes(setMarriageTypes, setFetcherror);
    getAllEmploymentSectors(setEmploymentSectors, setFetcherror);
    getAllEmploymentStatuses(setEmploymentStatuses, setFetcherror);
    getAllRoles(setRoles, setFetcherror);
    getAllZones(setZones, setFetcherror);

    // For Getting the zone
    getAllRegions(setAllRegions, setFetcherror);
  }, []);



useEffect(() => {
  if (selectedCountry?.id) {
    getCountryRegions(setRegions, setFetcherror, selectedCountry.id);
  }
}, [selectedCountry]);

useEffect(() => {
  if (selectedRegion?.id) {
    getRegionDistricts(setDistricts, setFetcherror, selectedRegion.id);
  }
}, [selectedRegion]);

useEffect(() => {
  if (selectedDistrict?.id) {
    getDistrictWards(setWards, setFetcherror, selectedDistrict.id);
  }
}, [selectedDistrict]);
  
  

const handleOnEditSelect = (tabledata) => {
  getAllBroadCategories(setBroadCategories, setFetcherror);
  getAllEducationLevels(setEducationLevels, setFetcherror);
  getAllReligions(setReligions, setFetcherror);
  getAllTribes(setTribes, setFetcherror);
  getAllMaritalStatuses(setMaritalStatuses, setFetcherror);
  getAllVulnerabilities(setVulnerabilities, setFetcherror);
  getAllDisabilities(setDisabilities, setFetcherror);
  getAllMarriageTypes(setMarriageTypes, setFetcherror);
  getAllEmploymentSectors(setEmploymentSectors, setFetcherror);
  getAllEmploymentStatuses(setEmploymentStatuses, setFetcherror);
  getAllRoles(setRoles, setFetcherror);
  getAllZones(setZones, setFetcherror);
  

};


const handleOnEditSelectPortal = (tabledata) => {
   
  const editSex = [{ id: 1, name: "MALE", namesw: "KIUME" }, { id: 2, name: "FEMALE", namesw: "KIKE" }].find(
    (item) => item.name === tabledata?.sex
  );

  
  setPortalSubmissionpkid(tabledata?.id);
  

  setSelectedSexReporter(editSex);
  const editRole = roles.find((item) => item.name === "Citizen");
  setSelectedReporterRole(editRole);

  setFistNameReporter(tabledata?.firstname);
  setLastNameReporter(tabledata?.lastname);
  setPhoneReporter(tabledata?.phone);
  setEmailReporter(tabledata?.email);
  setIncidentDescription(tabledata?.eventdescription);
  setStreet(tabledata?.street);
  setEventDate(new Date(tabledata?.eventdate));



  const editCountry = countries.find((item) => item.name === tabledata?.country);
  setSelectedCountry(editCountry);

  setSelectedZone(zones?.find((z) => z.id === allRegions?.find((item) => item.name === tabledata?.region)?.zone_id));

  const tempRegion = tabledata?.region;
  const tempDistrict = tabledata?.district;
  const tempWard = tabledata?.ward;

  getCountryRegions((fetchedRegions) => {
    setRegions(fetchedRegions);
    const editRegion = fetchedRegions.find((item) => item.name === tempRegion);
    setSelectedRegion(editRegion);

    // Fetch districts after region is selected
    getRegionDistricts((fetchedDistricts) => {
      setDistricts(fetchedDistricts);
      const editDistrict = fetchedDistricts.find((item) => item.name === tempDistrict);
      setSelectedDistrict(editDistrict);

      // Fetch wards after district is selected
      getDistrictWards((fetchedWards) => {
        setWards(fetchedWards);
        const editWard = fetchedWards.find((item) => item.name === tempWard);
        setSelectedWard(editWard);
      }, setFetcherror, editDistrict?.id);
    }, setFetcherror, editRegion?.id);
  }, setFetcherror, editCountry?.id);

    
  }


 
  const finalrolesArray = roles.filter((item) => item?.name !== "Admin");
  
  const handleSelectFile = (event) => {
      setFiles(event.files)
  }

  const handleRemoveFile = (event) => {
    const newFilesArray = files?.filter((xfile) => xfile.name !== event?.file?.name);
    setFiles(newFilesArray);
 }
  
  const handleFileUpload = (event) => {
    fileUploadRef.current.clear();
  };


  const operatorinitiated =  (auntheticatedUser?.role === "Admin" || auntheticatedUser?.role === "Operator" || auntheticatedUser?.role === "LHRCstaff") ? true:false
   const user_id = operatorinitiated? undefined: auntheticatedUser?.id;
 

  const hadleSubmit = () => {

    createIncident(
      fistNameReporter, setFistNameReporter,
      lastNameReporter, setLastNameReporter,
      selectedReporterRole,setSelectedReporterRole,
      phoneReporter, setPhoneReporter,
      emailReporter, setEmailReporter,
      selectedSexReporter, setSelectedSexReporter,
      incidentDescription, setIncidentDescription,
      selectedCountry, setSelectedCountry,
      selectedRegion, setSelectedRegion,
      selectedDistrict, setSelectedDistrict,
      selectedWard, setSelectedWard,
      street, setStreet,
      eventDate, setEventDate,
      selectedBroadCategory, setSelectedBroadCategory,
      selectedCategory, setSelectedCategory,
      selectedSubCategory, setSelectedSubCategory,
      selectedRight, setSelectedRight,
      stepsTaken, setStepsTaken,
      stepsDescription, setStepsDescription,

      fistNameVictim, setFistNameVictim,
      middleNameVictim, setMiddleNameVictim,
      lastNameVictim, setLastNameVictim,
      selectedSexVictim, setSelectSetSexVictim,
      selectedBirthDayVictim, setSelectedBirthDayVictim,
      selectedBirthMonthVictim, setSelectedBirthMonthVictim,
      birthYearVictim, setBirthYearVictim,
      phoneVictim, setPhoneVictim,
      selectedEducationLevelVictim, setESelectedEducationLevelVictim,
      selectedReligionVictim, setSelectedReligionVictim,
      selectedTribeVictim, setSelectedTribeVictim,
      childrenVictim, setChildrenVictim,
      selectedMaritalStatusVictim, setSelectedMaritalStatusVictim,
      selectedMarriageTypeVictim, setSelectedMarriageTypeVictim,
      selectedEmploymentStatusVictim, setSelectedEmploymentStatusVictim,
      selectedEmploymentSectorVictim, setSelectedEmploymentSectorVictim,
      isVictimVulnerable, setIsVictimVulnerable,
      selectedVulnerabilityVictim, setSelectedVulnerabilityVictim,
      isDisabled,setIsDisabled,
      selectedDisabilityVictim, setSelectedDisabilityVictim,

      fullNamePerpetrator, setFullNamePerpetrator,
      selectedSexPerpetrator, setSelectedSexPerpetrator,
      phonePerpetrator, setPhonePerpetrator,
      relationship, setRelationship,
      assitanceNeeded, setAssitanceNeeded,
      assitanceDescription, setAssitanceDescription,
      files, setFiles,incidentValidity,user_id,
      setFetcherror,
      handleAllToasts,
      handleFileUpload,
      operatorinitiated,
      selectedZone, setSelectedZone,
      
      (err, data) => {
        if (data) {
          setEditDialogVisible(false);
          editPortalSubmission(
            portalSubmissionpkid,
            true,
            false,
            setFetcherror,
            handleAllToasts,
            (err, data) => {
              if (data) {
                getSpecificPortalSubmissions(setPortalSubmissions, setFetcherror, setIsLoading, setFirst, setRows, undefined, setTotalCount, globalFilter);
                getNotifications(setNotifications, setIsLoadingNotifications, setFetcherrorNotifications, operatorinitiated? undefined: auntheticatedUser.id);
              }
            }
          
          );
        }
        
      }
    );
  }
// Edit Incident

  
  
  
  
const handleInputChangeDBSearch = (value) => setGlobalFilter(value);
  
useEffect(() => {
  const id = setTimeout(() => {
    getSpecificPortalSubmissions(setPortalSubmissions, setFetcherror,setIsLoading, setFirst, setRows, undefined, setTotalCount, globalFilter);
  }, 1000);
  return () => clearTimeout(id);
}, [globalFilter]);



  

  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  const extractTime = (timestamp) => { 
    const stamp = new Date(timestamp);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const dateTime = `${stamp.getDate()} ${months[stamp.getMonth()]} ${stamp.getFullYear()}  ${stamp.getHours()}:${stamp.getMinutes()}`;
    return dateTime;
  }

  const toProperCase = (textValue) => { 
    const newtextValue = textValue[0].toUpperCase() + textValue.substring(1).toLowerCase();
    return newtextValue;
  }

  const onPageChange = (event) => {
    getSpecificPortalSubmissions(setPortalSubmissions, setFetcherror,setIsLoading, setFirst, setRows, event, setTotalCount);
  };
  
  const limitOptions = [5, 10, 20, 30, 50, 100, 200, 500];
  const skeletonitems = Array.from({ length: 10 }, (v, i) => i);
  const maincardtitle= maincardtitlex ? maincardtitlex: (<div>Uprocessed Portal Submission</div>);
  
  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={maincardtitle}>
      <SearchToolBar
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                searchPlaceholder="Submissions"
                handleInputChangeDBSearch={handleInputChangeDBSearch}
        />
        
        {!isLoading &&
          <DataTable
            value={portalSubmissions}
            showGridlines
            emptyMessage="No Messages found"
          >
            <Column header="S/N" body={(rowData) => portalSubmissions.indexOf(rowData) + 1} style={{ width: '6%' }}> </Column>
            <Column
              style={{ width: '15%' }}
              header="Reporter Details"
              body={(rowData) => (
                <div className='flex flex-column'>
                  <div className='text-color-secondary font-bold'>Name:{rowData?.firstname} {rowData?.lastname}</div>
                  <div className='text-color-secondary'>Phone:{rowData?.phone}</div>
                  <div className='text-color-secondary'>Email:{rowData?.email}</div>
                  <div className='text-color-secondary'>Sex:{rowData?.sex}</div>
                </div>

              )} >
            
            </Column>
                    
            <Column
              style={{ width: '50%' }}
              header="Description"
              sortable
              body={(rowData) => (rowData.eventdescription)}>
            </Column>
          
            <Column
              className='w-10rem'
              header="Location & Status"
              body={(rowData) => (
                <div className='flex flex-column'>
                  <div className='text-color-secondary font-bold'>{rowData?.region}</div>
                  <div className='text-color-secondary'>{toProperCase(rowData?.district)}</div>
                  <div className='text-color-secondary'>{toProperCase(rowData?.ward)}</div>
                  <div className='mt-2'><Tag severity="success" value="Unprocessed"></Tag></div>
                  <div className='mt-2 text-sm'>{extractTime(rowData?.createdAt)}</div>
                </div>
              )}>
            </Column>
          
          
            <Column
              style={{ width: '6%' }}
              header="Actions"
              body={(rowData) => (
                <ProcessDiscard
                  pkid={rowData.id}
                  rowData={rowData}
                  setFetcherror={setFetcherror}
                  setSubmissions={setPortalSubmissions}
                  handleAllToasts={handleAllToasts}
                  submissionType="portal"
                  setEditDialogVisible={setEditDialogVisible}
                  handleOnEditSelectPortal={handleOnEditSelectPortal }
                        
                />)}>
            </Column>
          </DataTable>
        }
        
        {isLoading && 
          
          <DataTable value={skeletonitems} className="p-datatable-striped">
          <Column field="S/N" header="S/N" style={{ width: '6%' }} body={<Skeleton />}></Column>
          <Column field="Reporter Details" header="Reporter Details" style={{ width: '15%' }} body={<Skeleton />}sortable></Column>
          <Column field="Description" header="Description"  body={<Skeleton />} style={{ width: '45%' }} sortable></Column>
          <Column field="Location & Status" header="Location & Status" className='w-10rem' body={<Skeleton />}></Column>
          <Column field="Actions" header="Actions" style={{ width: '5%' }} body={<Skeleton />}></Column>
          </DataTable>
          }

          {!isLoading &&
            <Paginator
              first={first}
              rows={rows}
              totalRecords={totalCount}
              rowsPerPageOptions={limitOptions}
              onPageChange={onPageChange}
            />
          } 
        
        <Dialog visible={editDialogVisible} modal header={EditDialogHeader} headerClassName='mb-0 pb-0' style={{ width: '80rem' }} onHide={() => setEditDialogVisible(false)}>
          <IncidentForm
            fistNameReporter={fistNameReporter} setFistNameReporter={setFistNameReporter}
            lastNameReporter={lastNameReporter} setLastNameReporter={setLastNameReporter}
            selectedReporterRole={selectedReporterRole} setSelectedReporterRole={setSelectedReporterRole}
            phoneReporter={phoneReporter} setPhoneReporter={setPhoneReporter}
            emailReporter={emailReporter} setEmailReporter={setEmailReporter}
            selectedSexReporter={selectedSexReporter} setSelectedSexReporter={setSelectedSexReporter}
            incidentDescription={incidentDescription} setIncidentDescription={setIncidentDescription}
            selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry}
            selectedRegion={selectedRegion} setSelectedRegion={setSelectedRegion}
            selectedDistrict={selectedDistrict} setSelectedDistrict={setSelectedDistrict}
            selectedWard={selectedWard} setSelectedWard={setSelectedWard}
            street={street} setStreet={setStreet}
            eventDate={eventDate} setEventDate={setEventDate}
            selectedBroadCategory={selectedBroadCategory} setSelectedBroadCategory={setSelectedBroadCategory}
            selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory}
            selectedSubCategory={selectedSubCategory} setSelectedSubCategory={setSelectedSubCategory}
            selectedRight={selectedRight} setSelectedRight={setSelectedRight}
            stepsTaken={stepsTaken} setStepsTaken={setStepsTaken}
            stepsDescription={stepsDescription} setStepsDescription={setStepsDescription}
                        
            fistNameVictim={fistNameVictim} setFistNameVictim={setFistNameVictim}
            middleNameVictim={middleNameVictim} setMiddleNameVictim={setMiddleNameVictim}
            lastNameVictim={lastNameVictim} setLastNameVictim={setLastNameVictim}
            selectedSexVictim={selectedSexVictim} setSelectSetSexVictim={setSelectSetSexVictim}
            selectedBirthDayVictim={selectedBirthDayVictim} setSelectedBirthDayVictim={setSelectedBirthDayVictim}
            selectedBirthMonthVictim={selectedBirthMonthVictim} setSelectedBirthMonthVictim={setSelectedBirthMonthVictim}
            birthYearVictim={birthYearVictim} setBirthYearVictim={setBirthYearVictim}
            phoneVictim={phoneVictim} setPhoneVictim={setPhoneVictim}
            selectedEducationLevelVictim={selectedEducationLevelVictim} setESelectedEducationLevelVictim={setESelectedEducationLevelVictim}
            selectedReligionVictim={selectedReligionVictim} setSelectedReligionVictim={setSelectedReligionVictim}
            selectedTribeVictim={selectedTribeVictim} setSelectedTribeVictim={setSelectedTribeVictim}
            childrenVictim={childrenVictim} setChildrenVictim={setChildrenVictim}
            selectedMaritalStatusVictim={selectedMaritalStatusVictim} setSelectedMaritalStatusVictim={setSelectedMaritalStatusVictim}
            selectedMarriageTypeVictim={selectedMarriageTypeVictim} setSelectedMarriageTypeVictim={setSelectedMarriageTypeVictim}
            selectedEmploymentStatusVictim={selectedEmploymentStatusVictim} setSelectedEmploymentStatusVictim={setSelectedEmploymentStatusVictim}
            selectedEmploymentSectorVictim={selectedEmploymentSectorVictim} setSelectedEmploymentSectorVictim={setSelectedEmploymentSectorVictim}
            isVictimVulnerable={isVictimVulnerable} setIsVictimVulnerable={setIsVictimVulnerable}
            selectedVulnerabilityVictim={selectedVulnerabilityVictim} setSelectedVulnerabilityVictim={setSelectedVulnerabilityVictim}
            isDisabled={isDisabled} setIsDisabled={setIsDisabled}
            selectedDisabilityVictim={selectedDisabilityVictim} setSelectedDisabilityVictim={setSelectedDisabilityVictim}
            fullNamePerpetrator={fullNamePerpetrator} setFullNamePerpetrator={setFullNamePerpetrator}
            selectedSexPerpetrator={selectedSexPerpetrator} setSelectedSexPerpetrator={setSelectedSexPerpetrator}
            phonePerpetrator={phonePerpetrator} setPhonePerpetrator={setPhonePerpetrator}
            relationship={relationship} setRelationship={setRelationship}
            assitanceNeeded={assitanceNeeded} setAssitanceNeeded={setAssitanceNeeded}
            assitanceDescription={assitanceDescription} setAssitanceDescription={setAssitanceDescription}
            setFetcherror={setFetcherror} tribes={tribes}
            handleFileUpload={handleFileUpload}
            hadleSubmit={hadleSubmit}
            finalrolesArray={finalrolesArray} getCountryRegions={getCountryRegions}
            setRegions={setRegions} countries={countries}
            getRegionDistricts={getRegionDistricts} setDistricts={setDistricts}
            regions={regions} getDistrictWards={getDistrictWards}
            setWards={setWards} districts={districts}
            wards={wards} getBroadCategoryCategories={getBroadCategoryCategories}
            setCategories={setCategories} getBroadCategoryRights={getBroadCategoryRights}
            setRights={setRights} broadCategories={broadCategories}
            getCategorySubCategories={getCategorySubCategories} setSubCategories={setSubCategories}
            categories={categories} subCategories={subCategories}
            rights={rights} daysArray={daysArray}
            monthsArray={monthsArray} educationLevels={educationLevels}
            religions={religions} maritalStatuses={maritalStatuses}
            employmentStatuses={employmentStatuses} vulnerabilities={vulnerabilities}
            marriageTypes={marriageTypes} employmentSectors={employmentSectors}
            disabilities={disabilities} fileUploadRef={fileUploadRef}
            handleSelectFile={handleSelectFile} handleRemoveFile={handleRemoveFile}
            // incidentValidity={incidentValidity} setIncidentValidity={setIncidentValidity}
            validity={incidentValidity} setValidity={setIncidentValidity}
            setSelectedZone={setSelectedZone}
            zones={ zones}
              />

               
        </Dialog>


                
      </Card>

   
    </div>
  )
}

export default PortalSubmissions